import Vue from 'vue';

interface Data {
  comPostButton: NodeListOf<Element> | null;
  comReadButton: Element | null;
  comPostButtonRound: NodeListOf<Element> | null;
}

interface Methods {
  commentEvent: (type: string) => void;
  addCommentEventListener: () => void;
  removeCommentEventListener: () => void;
}
export default Vue.extend<Data, Methods, unknown, unknown>({
  data() {
    return {
      comPostButton: null,
      comReadButton: null,
      comPostButtonRound: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.addCommentEventListener();
    });
  },
  beforeDestroy() {
    this.removeCommentEventListener();
  },
  methods: {
    commentEvent(type) {
      if (type === 'login') {
        return false;
      }

      this.$store.commit('analytics/setClickEvent', {
        googleAnalytics: {
          eventName: 'ANALYTICS_COMMENTS_CLICK',
          eventData: {
            type,
            data: {
              view: 'Comment',
              articleId: this.$route.params.id,
            },
          },
        },
      });
    },
    addCommentEventListener() {
      setTimeout(() => {
        this.comPostButton =
          (document.getElementById('comments-listing') && document.getElementById('comments-listing')?.querySelectorAll('.input-login')) || null;
        this.comPostButtonRound =
          (document.getElementById('comments-listing') && document.getElementById('comments-listing')?.querySelectorAll('.button-publish-circle')) || null;

        this.comReadButton = (document.getElementById('comments-listing') && document.getElementById('comments-listing')?.querySelector('.input-read')) || null;
        if (this.comPostButtonRound) {
          [...this.comPostButtonRound].forEach((button) => {
            button.addEventListener('click', () => this.commentEvent(button.textContent?.toLowerCase() === 'logi sisse' ? 'login' : 'post'), false);
          });
        }
        if (this.comPostButton) {
          [...this.comPostButton].forEach((button) => {
            button.addEventListener('click', () => this.commentEvent(button.textContent?.toLowerCase() === 'logi sisse' ? 'login' : 'post'), false);
          });
        }
        if (this.comReadButton) {
          this.comReadButton.addEventListener('click', () => this.commentEvent('read'), false);
        }
      }, 2500);
    },
    removeCommentEventListener() {
      if (this.comReadButton) {
        this.comReadButton.removeEventListener('click', () => this.commentEvent('read'));
      }
      if (this.comPostButton) {
        [...this.comPostButton].forEach((button) => {
          button.addEventListener('click', () => this.commentEvent(button.textContent?.toLowerCase() === 'logi sisse' ? 'login' : 'post'), false);
        });
      }
      if (this.comPostButtonRound) {
        [...this.comPostButtonRound].forEach((button) => {
          button.addEventListener('click', () => this.commentEvent(button.textContent?.toLowerCase() === 'logi sisse' ? 'login' : 'post'), false);
        });
      }
    },
  },
});
